module.exports = __webpack_public_path__ + "static/media/practice_test_mobile.76d1634a.png";